<template>
  <div v-if="cookieModalVisible">
    <cookie-notice v-if="cookieNoticeVisible && cookieModalVisible"></cookie-notice>
    <cookie-settings v-if="cookieSettingsVisible && cookieModalVisible"></cookie-settings>
  </div>
</template>

<script>
import CookieSettings from './CookieSettings'
import CookieNotice from './CookieNotice'
import { mapState } from 'vuex'
export default {
  name: 'CookieModal',
  components: {
    CookieSettings,
    CookieNotice
  },
  computed: {
    ...mapState(['cookieModalVisible', 'cookieNoticeVisible', 'cookieSettingsVisible', 'SessionCookiesState'])
  }
}
</script>
